import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {alpha, useTheme} from '@mui/material/styles';

type Props = {
  label: string;
  open: boolean;
  children: React.ReactNode;
  /** Subtle onboarding cue for SETUP — only when sidebar expanded */
  setupHint?: React.ReactNode;
};

export function SidebarSection({label, open, children, setupHint}: Props) {
  const theme = useTheme();

  if (!open) {
    return (
      <Box component="nav" sx={{mt: 2, '&:first-of-type': {mt: 0}}}>
        {children}
      </Box>
    );
  }

  return (
    <Box component="section" sx={{mt: 2.5, '&:first-of-type': {mt: 0}}}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          pl: 0.5,
          pr: 0.25,
          mb: 0.75,
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontSize: '0.65rem',
            fontWeight: 700,
            letterSpacing: '0.12em',
            color: alpha(theme.palette.text.secondary, 0.85),
            lineHeight: 1,
          }}
        >
          {label}
        </Typography>
        {setupHint}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.25,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
